import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material'
import { ExitToApp } from '@mui/icons-material'
import styled from 'styled-components'

const PromptContainer = styled(Box)`
  padding: 8px 0;
`

const InfoBox = styled(Box)`
  padding: 16px;
  background: rgba(239, 68, 68, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(239, 68, 68, 0.2);
  margin-top: 16px;
`

export default function CheckoutPrompt({ open, onClose, onCheckout, checkingOut }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '12px',
        },
      }}
    >
      <DialogTitle sx={{ fontWeight: 600 }}>
        Check Out
      </DialogTitle>
      <DialogContent>
        <PromptContainer>
          <Typography variant="body1" sx={{ mb: 2 }}>
            You are currently checked in. Would you like to check out before proceeding?
          </Typography>

          <InfoBox>
            <Typography variant="body2" color="text.secondary">
              Checking out will end your current session. You can check in again when needed.
            </Typography>
          </InfoBox>
        </PromptContainer>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button onClick={onClose} variant="outlined" disabled={checkingOut}>
          Stay Checked In
        </Button>
        <Button
          onClick={onCheckout}
          variant="contained"
          color="error"
          disabled={checkingOut}
          startIcon={<ExitToApp />}
        >
          {checkingOut ? 'Checking Out...' : 'Check Out'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

